<template>
  <a-dropdown :trigger="['click']" placement="bottomRight" @visibleChange="handleVisibleChange">
    <div :class="$style.dropdown">
      <a-badge :count="count">
        <a-avatar
          shape="square"
          icon="bell"
          size="large"
          :class="$style.avatar"
        />
      </a-badge>
    </div>
    <div
      slot="overlay"
      :style="this.settings['isMobileView'] ? {width: '360px'} : {}"
      class="bg-white shadow rounded p-4"
    >
      <section key="0">
        <div>
          <p class="font-weight-bold text-muted mb-1">Notifications</p>
        </div>
        <vue-custom-scrollbar class="scroll-area" style="max-height: 300px;">
          <template v-if="notifications.length">
            <section v-for="notification in notifications" :key="notification.id">
              <div class="d-flex py-2 pr-3">
                <div class="pr-2">
                  <a-avatar icon="bell" :class="getNotificationStatusBg(notification.data)"/>
                </div>
                <div>
                  <p class="mb-0">
                    {{notification.data.message}}
                  </p>
                  <p class="text-muted activity-time mb-0">{{moment(notification.updated_at).format('LLL')}}</p>
                </div>
            </div>
            </section>
          </template>
          <template v-else>
            <div class="pb-3 px-5">
              <no-data text="You don't have any notifications yet!" />
            </div>
          </template>
        </vue-custom-scrollbar>
      </section>
    </div>
  </a-dropdown>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import NoData from '@/components/layout/NoData/index'
import vueCustomScrollbar from 'vue-custom-scrollbar'
export default {
  components: {
    vueCustomScrollbar,
    NoData,
  },
  data: function () {
    return {
      count: 0,
      spining: false,
      notifications: [],
    }
  },
  computed: {
    ...mapState(['user', 'settings']),
  },
  mounted: function() {
    this.getNotifications()
    window.Echo.channel('DemoChannel')
      .listen('DemoEvent', (e) => {
        this.addCount()
        this.$message.info('You got a new notification!')
      })
    window.Echo.private('App.Models.User.' + this.user.user.id)
      .notification((notification) => {
        this.addCount()
        this.$message.info('You got a new notification!')
        this.getNotifications()
      })
  },
  methods: {
    moment,
    addCount() {
      this.count = this.count + 1
    },
    resetCount() {
      this.count = 0
    },
    handleVisibleChange() {
      this.readNotifications()
      this.resetCount()
    },
    getNotifications() {
      this.spinning = true
      this.$http.get('/api/notification/all', {
        params: {

        },
      }).then(({ data }) => {
        this.notifications = data.data
        this.count = data.unread
        this.spinning = false
      }).catch((e) => {
        console.log(e)
        this.spining = false
      })
    },
    readNotifications() {
      this.spinning = true
      this.$http.post('/api/notification/read')
        .then(({ data }) => {

        }).catch((e) => {
          console.log(e)
        })
    },
    getNotificationStatusBg(notificationData) {
      if (notificationData.status) {
        if (notificationData.status === 'Success') {
          return 'bg-success'
        } else if (notificationData.status === 'Failed') {
          return 'bg-danger'
        } else {
          return 'bg-light'
        }
      } else {
        return ''
      }
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
